import { useState, useEffect } from "react";
import moment from "moment-timezone";
import { useTimezone } from "../context/TimezoneContext";

export const useFormattedDate = (
  dateInput: Date | string,
  format: string = "YYYY-MM-DD HH:mm:ss"
) => {
  const { timezone } = useTimezone();
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    if (dateInput) {
      const m = moment(dateInput).utc(true).tz(timezone);
      setFormattedDate(m.format(format));
    }
  }, [dateInput, timezone, format]);

  return formattedDate;
};
